module.exports = __webpack_public_path__ + "media/how_to_win_a_scholarship/how-to-win-a-scholarship_635x150-db81b366.png";